// secondsFormatted filter
//
//    {{ numberSeconds | secondsFormatted }}

import { secondsToFormattedLabel } from '../utils/date';

angular.module('app.filters').filter('secondsFormatted', ($filter) => {
  'ngInject';
  return (seconds, showSeconds = true, showHoursIfZero = true) => {
    return secondsToFormattedLabel(seconds, showSeconds, showHoursIfZero);
  };
});



// WEBPACK FOOTER //
// ./app/filters/seconds-formatted.js